import { z } from "zod";
import { conversionGetBaseSchema } from "./conversionGetBaseSchema";
import { conversionFiltersGetSchema } from "./conversionFiltersGetSchema";

export const performedCustomEventConversionGetSchema = z.object({
  ...conversionGetBaseSchema.shape,
  event_type: z.literal("TrackedUserBehavior::PerformedCustomEvent"),
  blocklisted: z.null(),
  custom_event_name: z.string().nullable(),
  filter_description: z.string().optional(),
  filters: conversionFiltersGetSchema.optional(),
  hard_deleted: z.null(),
});
